export const initialState = {
  getNotifications: {
    loading: false,
    success: false,
    data: [],
    error: null,
  },
};
